import { createTheme } from '@mui/material/styles';
import palette from './palette';
import darkPalette from './darkPalette';
import typography from './typography';
import overrides from './overrides';

const typogprahyLight = typography(palette);
const typogprahyDark = typography(darkPalette);
const baseTheme = createTheme({
  components: overrides,
  shape: {
    borderRadius: '20px'
  }
});

const lightThemeTesting = createTheme({
  ...baseTheme,
  typography: typogprahyLight,
  palette,
  components: {
    ...baseTheme.components,
    MuiWithWidth: {
      defaultProps: { initialWidth: 'lg' }
    }
  }
});

const lightTheme = createTheme({
  ...baseTheme,
  typography: typogprahyLight,
  palette
});

const darkTheme = createTheme({
  ...baseTheme,
  typography: typogprahyDark,
  palette: darkPalette
});

export { darkTheme, lightTheme, lightThemeTesting };
